import { type FieldError } from 'react-hook-form';

/**
 * Safely extracts error message from FieldError object or string
 */
export function getErrorMessage(error?: string | FieldError | any): string {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error.message) return error.message;
  return '';
}
